import { atomWithReset } from "jotai/utils";

export const isTrimModeActiveAtom = atomWithReset(false);